import styled from 'styled-components' 

import Lottie from 'react-lottie';

export const CommomContainer = styled.div.attrs({ 
})`          
    position: relative;
    padding: 0px 0 0;

    background: var(--black-color);
`; 

export const CommomTitle = styled.div.attrs({  
})`          
    font-size: 23px;
    font-weight: bold;
    line-height: 1.3em;
    color: var(--primary-color);
    margin: 0;
    
    width: 100%;
    max-width: 360px;
    text-align: center;
`;  
 

export const CommomText = styled.div.attrs({  
})`          
    font-size: 18px;
    line-height: 1.2em;
    color: var(--white-color);
    margin: 15px 0 0 0;

    width: 100%;
    max-width: 360px;
    text-align: center;
`;  
 


export const CommomImageBanner = styled.img.attrs({
    src:'/images/capa_site.png',
    alt:'Conversa com personagens bíblicos no TiqChat',
    width:'540',
    height:'400'
})`
    width: 100%;
    max-width: 540px;
    height: auto;
    margin: 15px 0 0 0;
    border-radius: 10px;

    @media(max-width: 767px){
        margin-top: 20px;
        margin-bottom: 20px;
    }
`;

export const BannerLogo = styled.img.attrs({
    src:'/icons/logo_tiq_chat.png',
    alt:'TiqChat — Converse com personagens bíblicos',
    width:'210',
    height:'70'
})`
    margin: 0 auto 20px;
    width: 100%;
    max-width: 210px;
    height: auto;
    `; 
export const BannerText = styled.div.attrs({ 
})`           
        font-size: 20px;
        line-height: 1.4em;
        color: var(--white-color);    
        max-width: 62ch;
        margin: 0 auto 6px;
        text-wrap: balance;
        text-align: center;

        @media (max-width: 600px) {
            font-size: 18px;
        }
`; 


export const BannerCenterActions = styled.div.attrs({ 
})`            
    margin: 10px auto 10px;
    flex:1;
    width: 160px;
`; 

export const CommomCentred = styled.div.attrs({ 
})`          
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    ${
        props => props.spaced ? `
            padding-top: 20px;
        ` : ``
    }
`;

export const ContainerLoginContent = styled.div.attrs({
})`
    position: sticky;
    top: 0;
    z-index: 100;
    padding: 0;
    background: rgba(44, 44, 44, 0.95);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border-bottom: 1px solid rgba(255, 153, 0, 0.2);
`;

export const LoginContent = styled.div.attrs({
})`
    margin: 8px 16px 8px auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: fit-content;
`; 